module.exports = __webpack_public_path__ + "static/media/BANNER - user manual_V6.a2b8a9d5.jpg";